import Training from 'actions/training';

export default Training.createReducer();